import { Flywire } from './start';

window.FlywireSDK = Flywire;
